<script lang="ts">
	import { page } from '$app/stores';
	import { createExpenseNoteContext } from '$lib/components/route-details/expense-note/expense-note-context';

	$: data = $page.data;
	$: ({ locale } = data);

	createExpenseNoteContext(locale);
</script>

<slot />
